export const JUSPAY_TOKENIZE_URL = "https://api.juspay.in/card/tokenize";
export const JUSPAY_REDIRECT_URL = "https://api.juspay.in/txns";
export const JUSPAY_SWIGGY_RETURN_URL = "https://www.swiggy.com/justpay/response.php";
export const JUSPAY_END_URLS_REGEX = ".*www.swiggy.com/justpay/response.*";
export const SM_JUSPAY_END_URLS_REGEX = ".*.swiggy.com/swiggy-money(/[^/]*)?/payments.*";
export const DEFAULT_JUSPAY_MERCHANTID = "com.swiggy";
export const INIT_JUSPAY_TIMEOUT = 20 * 1000; // 20 secs

export enum JUSPAY_SDK_REQUEST_FAIL_INSTANCE {
    AVAILABLE = "is_sdk_available",
    INIT = "sdk_init",
}

export const JUSPAY_API_HOST = "https://api.juspay.in";

export const JUSPAY_ENDPOINTS = {
    FINGERPRINT: "/v2/card/fingerprint",
};

export const JUSPAY_CARD_FINGERPRINT_API_TIMEOUT = 4000;

export const DEFAULT_JUSPAY_V3_TENANT = "SW-FOOD";
